import { useEffect, useState } from 'react';
import accountApis from '../../../../services/accountApis';
import { AxiosResponse } from 'axios';
import { IGetEmployeeSummaryResponse } from '../types';

const useGetEmployeeSummary = () => {
  const [data, setData] = useState<IGetEmployeeSummaryResponse>();
  const getEmployeeSummary = async () => {
    try {
      const response: AxiosResponse<{ data: IGetEmployeeSummaryResponse }> =
        await accountApis.getEmployeeSummary();
      setData(response.data.data);
    } catch (error) {
      setData(undefined);
    }
  };

  useEffect(() => {
    getEmployeeSummary();
  }, []);

  return { data, getEmployeeSummary };
};

export default useGetEmployeeSummary;
